// @flow

import * as React from 'react';
import Box from 'sail/Box';

type Props = {
  onClick?: () => void,
  style?: Object,
};

const Arrow = ({onClick, style = {}}: Props) => (
  <Box className="Arrow" style={style} onClick={onClick} />
);

export default Arrow;
